import React, { Component } from 'react';

import '../css/menu.css'

import logocabecera from '../img/logo-padilla-cabecera.svg'
import logosolo from '../img/logo-padilla-solo.svg'
import facebook from '../img/facebook-ico.svg'
import twitter from '../img/twitter-ico.svg'
// import whatsapp from '../img/whatsapp-ico.svg'

class Menu extends Component {
  render() {
    return (
      <div className="menutodo container-fluid fixed-top">
        <div className="menu row align-items-center justify-content-between">

          <div className="col-lg-auto col-auto">
            <div className="nav">
              <img className="logocabecera" src={logocabecera} alt=""/>
              <img className="logosolo" src={logosolo} alt=""/>
            </div>
          </div>

          <div className="movilmenu">
            <nav id="navigation" className="navtodo">

              <div className="control-menu">
                <a href="#navigation" className="open"><span>MENU</span></a>
                <a href="#cerrado" className="close"><span>CERRAR</span></a>
              </div>

              <ul className="nav-items">
                <li><a className="nav-link" href="#inicio"><span>Inicio</span></a></li>
                <li><a className="nav-link" href="#marcas"><span>Marcas</span></a></li>
                <li><a className="nav-link" href="#quienessomos"><span>Quienes Somos</span></a></li>
                <li><a className="nav-link" href="#sucursales"><span>Sucursales</span></a></li>
                <li><a className="nav-link" href="#contactos"><span>Contactos</span></a></li>
       
              </ul>

            </nav>
          </div>

          <div className="menuitems col-lg-auto">

            <nav>
              <ul className="nav">
                <li className="nav-item">
                  <a className="nav-link" href="#inicio">Inicio</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#marcas">Marcas</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#quienessomos">Quienes Somos</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#sucursales">Sucursales</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#contactos">Contactos</a>
                </li>
                
              </ul>
            </nav>

          </div>

          <div className="redestodo col-lg-auto col-auto">
            <div className="nav">
              <div><a href="https://www.facebook.com/Ferrepadillaecu" target="_blank"><img className="redes efectohover" src={facebook} alt=""/></a></div>
              <div><a href="https://twitter.com/ferrepadilla" target="_blank"><img className="redes efectohover" src={twitter} alt=""/></a></div>
              {/* <div><a href="https://api.whatsapp.com/send?phone=593993185592" target="_blank"><img className="redes efectohover" src={whatsapp} alt=""/></a></div> */}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Menu;
